import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { toggleFlag } from './toggleFlag';

export const historicalData: FormSnippet<
  DiscoverySettingsObject,
  { historicalData: boolean }
> = {
  render: ({ form }) => (
    <>
      <FormSwitch
        control={form.control}
        name='historicalData'
        label='Save historical data'
        description='Slightly faster if disabled, could have impact on some tables though.'
      />
    </>
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.historicalData =
      !model.disabledPostDiscoveryActions?.includes('historicalData');
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.disabledPostDiscoveryActions ??= [];

    modelDraft.disabledPostDiscoveryActions = toggleFlag(
      modelDraft.disabledPostDiscoveryActions,
      'historicalData',
      transformedValues.historicalData,
    );
  },
  schema: z.object({
    historicalData: z.boolean(),
  }),
};
